<template>
  <div class="ma-3">
    <OCol fill-x class="pa-3 children-ma-3">
      <v-form ref="theForm" v-model="isValid">
        <OTextField label="Nome" v-model="value.name" :rules="[isSet]"/>

        <v-textarea label="Descrição" v-model="value.description" />

        <div class="d-flex">
          <OTextField class="w-6 pr-6" label="Baud Rate" v-model="value.baudRate" />
          <OTextField class="w-6" label="Send ACK" v-model="value.sendAck" />
        </div>

        <ORow>
          <OCapCont class="oderon-col-4" label="Criado em">
            {{ value.createdAt | moment('DD/MM/YYYY HH:mm') }}
          </OCapCont>
          <OCapCont class="oderon-col-4" label="Atualizado em">
            {{ value.updatedAt | moment('DD/MM/YYYY HH:mm') }}
          </OCapCont>
          <OCapCont class="oderon-col-4" label="Desativado em">
            {{ value.deletedAt | moment('DD/MM/YYYY HH:mm') }}
          </OCapCont>
        </ORow>
      </v-form>

      <ORow right style="width: auto" class="mt-12">
        <v-btn text class="mr-2" :disabled="!isDirty" @click="$emit('reload')">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="!isDirty" @click="save">Salvar</v-btn>
      </ORow>
    </OCol>
  </div>
</template>

<script>
import EditStore from './EditStore'
import { isSet } from 'oderon-vue/utils.js'

export default {
  tabTitle: 'Geral',
  data() {
    return { isSet, isValid: false }
  },
  computed: {
    value() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    }
  },
  methods: {
    save() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.$rootLoading(async () => {
          const { name, description, baudRate, sendAck } = this.value
          await EditStore.patch({ name, description, baudRate, sendAck })
          this.$snack('Salvo com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
